/* MistPour theme interactions */
(function () {
  "use strict";

  /* Announcement bar: shrink on scroll + keep header offset below it */
  var announceBound = false;
  function initAnnounce() {
    var setOffset = function () {
      var ann = document.querySelector(".announce");
      var h = ann && ann.offsetParent !== null ? ann.offsetHeight : 0;
      document.documentElement.style.setProperty("--announce-h", h + "px");
    };
    var onScroll = function () {
      var ann = document.querySelector(".announce");
      if (ann) ann.classList.toggle("shrunk", window.scrollY > 40);
      setOffset();
    };
    if (!announceBound) {
      announceBound = true;
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", setOffset);
    }
    onScroll();
  }

  /* Sticky header shadow on scroll */
  function initHeader(root) {
    var header = (root || document).querySelector(".site-header");
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle("scrolled", window.scrollY > 4);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    var toggle = header.querySelector(".nav-toggle");
    var nav = header.querySelector(".site-nav");
    if (toggle && nav) {
      toggle.addEventListener("click", function () {
        var open = nav.classList.toggle("open");
        toggle.setAttribute("aria-expanded", String(open));
      });
      nav.addEventListener("click", function (e) {
        if (e.target.tagName === "A") {
          nav.classList.remove("open");
          toggle.setAttribute("aria-expanded", "false");
        }
      });
    }
  }

  /* FAQ accordion — exclusive: opening one closes the others */
  function initFaq(root) {
    (root || document).querySelectorAll(".faq-item").forEach(function (item) {
      if (item.dataset.faqInit) return;
      item.dataset.faqInit = "1";
      var btn = item.querySelector(".faq-q");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var grid = item.closest(".faq-grid") || item.parentElement;
        var wasOpen = item.classList.contains("open");
        grid.querySelectorAll(".faq-item.open").forEach(function (other) {
          other.classList.remove("open");
          var q = other.querySelector(".faq-q");
          if (q) q.setAttribute("aria-expanded", "false");
        });
        if (!wasOpen) {
          item.classList.add("open");
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  /* Product page: thumbnails, quantity stepper, variant swatches */
  function formatMoney(cents, symbol) {
    return symbol + (cents / 100).toFixed(2);
  }

  function initProduct(root) {
    (root || document).querySelectorAll(".product-page").forEach(function (page) {
      if (page.dataset.ppInit) return;
      page.dataset.ppInit = "1";

      /* Bundle deal cards (sync with quantity) */
      var dealCards = page.querySelectorAll(".deal-card");
      var dealQty = page.querySelector(".qty-stepper input");
      function markDeals() {
        if (!dealCards.length || !dealQty) return;
        var q = parseInt(dealQty.value, 10) || 1;
        dealCards.forEach(function (c) { c.classList.toggle("selected", Number(c.dataset.qty) === q); });
      }
      dealCards.forEach(function (card) {
        card.addEventListener("click", function () {
          if (dealQty) dealQty.value = card.dataset.qty || 1;
          markDeals();
        });
      });
      markDeals();

      /* Quantity stepper */
      page.querySelectorAll(".qty-btn").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var input = btn.parentElement.querySelector("input");
          var v = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, v + Number(btn.dataset.delta));
          markDeals();
        });
      });

      /* "See all" toggle for long variant lists */
      page.querySelectorAll(".swatch-more").forEach(function (btn) {
        btn.dataset.label = btn.textContent.trim();
        btn.addEventListener("click", function () {
          var group = btn.closest(".swatch-group");
          var expanded = group.classList.toggle("expanded");
          btn.textContent = expanded ? "Show less" : btn.dataset.label;
        });
      });
      page.querySelectorAll(".swatch-group").forEach(function (g) {
        var hiddenActive = g.querySelector(".swatch.active.swatch-hidden");
        if (hiddenActive) {
          g.classList.add("expanded");
          var mb = g.querySelector(".swatch-more");
          if (mb) mb.textContent = "Show less";
        }
      });

      /* Thumbnails: arrows + active state + main image swap */
      var mainImg = page.querySelector(".product-main-image");
      page.querySelectorAll(".thumbs-btn").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var row = btn.parentElement.querySelector(".thumb-row");
          if (row) row.scrollBy({ left: 160 * Number(btn.dataset.dir || 1), behavior: "smooth" });
        });
      });
      page.querySelectorAll(".thumb-row").forEach(function (row) {
        row.addEventListener("click", function (e) {
          var t = e.target.closest(".thumb");
          if (!t) return;
          row.querySelectorAll(".thumb.active").forEach(function (x) { x.classList.remove("active"); });
          t.classList.add("active");
          if (mainImg && t.dataset.full) {
            mainImg.src = t.dataset.full;
            mainImg.removeAttribute("srcset");
          }
        });
      });

      /* Variant swatches */
      var dataEl = page.querySelector(".pp-variants");
      var variants = null;
      try { variants = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (err) { variants = null; }
      var groups = Array.prototype.slice.call(page.querySelectorAll(".swatch-group"));

      function currentVariant() {
        var selected = groups.map(function (g) {
          var a = g.querySelector(".swatch.active");
          return a ? a.dataset.value : null;
        });
        return variants.find(function (v) {
          return selected.every(function (s, i) { return v.options[i] === s; });
        });
      }

      function applyVariant(v) {
        var form = page.querySelector(".product-form");
        var atc = page.querySelector("[data-atc]");
        var atcLabel = page.querySelector("[data-atc-label]");
        if (!v) {
          if (atc) atc.disabled = true;
          if (atcLabel) atcLabel.textContent = "Unavailable";
          return;
        }
        if (form) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = v.id;
        }
        var priceWrap = page.querySelector(".pp-price");
        if (priceWrap) {
          var sym = priceWrap.dataset.symbol || "$";
          var priceEl = priceWrap.querySelector("[data-price]");
          var compEl = priceWrap.querySelector("[data-compare]");
          var saveEl = priceWrap.querySelector("[data-save]");
          if (priceEl) priceEl.textContent = formatMoney(v.price, sym);
          if (v.compare_at_price && v.compare_at_price > v.price) {
            if (compEl) { compEl.hidden = false; compEl.textContent = formatMoney(v.compare_at_price, sym); }
            if (saveEl) {
              saveEl.hidden = false;
              saveEl.textContent = "Save " + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + "%";
            }
          } else {
            if (compEl) compEl.hidden = true;
            if (saveEl) saveEl.hidden = true;
          }
        }
        if (atc) atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? (atcLabel.dataset.default || "Add to Cart") : "Sold out";
      }

      groups.forEach(function (g) {
        g.addEventListener("click", function (e) {
          var s = e.target.closest(".swatch");
          if (!s) return;
          g.querySelectorAll(".swatch.active").forEach(function (x) { x.classList.remove("active"); });
          s.classList.add("active");
          if (variants) applyVariant(currentVariant());
        });
      });

      var initialLabel = page.querySelector("[data-atc-label]");
      if (initialLabel) initialLabel.dataset.default = initialLabel.textContent.trim();
    });
  }

  /* Scroll-reveal animations — elements entering together fade in staggered */
  var io = null;
  function initReveal(root) {
    if (document.body.hasAttribute("data-reveal-off")) return;
    var els = (root || document).querySelectorAll(".reveal:not(.in)");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(
        function (entries) {
          var i = 0;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var el = entry.target;
              el.style.transitionDelay = (i * 70) + "ms";
              i++;
              el.classList.add("in");
              setTimeout(function () { el.style.transitionDelay = ""; }, 900 + i * 70);
              io.unobserve(el);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* Lightbox popup — created once, shared by gallery and review media */
  function ensureLightbox() {
    var lb = document.getElementById("theme-lightbox");
    if (lb) return lb;
    lb = document.createElement("div");
    lb.id = "theme-lightbox";
    lb.className = "lightbox";
    lb.hidden = true;
    lb.innerHTML =
      '<div class="lightbox-inner">' +
      '<button class="lightbox-close" type="button" aria-label="Close">&times;</button>' +
      '<div class="lightbox-body"></div>' +
      "</div>";
    document.body.appendChild(lb);
    return lb;
  }

  function lbClose() {
    var lb = document.getElementById("theme-lightbox");
    if (!lb) return;
    lb.hidden = true;
    document.body.classList.remove("lb-open");
    lb.querySelector(".lightbox-body").innerHTML = "";
  }

  function lbOpen(tpl) {
    var lb = ensureLightbox();
    var body = lb.querySelector(".lightbox-body");
    body.innerHTML = "";
    body.appendChild(tpl.content.cloneNode(true));
    lb.hidden = false;
    document.body.classList.add("lb-open");
  }

  /* Delegated handlers — survive theme editor section re-renders */
  var delegatesBound = false;
  function bindDelegates() {
    if (delegatesBound) return;
    delegatesBound = true;

    document.addEventListener("click", function (e) {
      /* Gallery carousel arrows */
      var galBtn = e.target.closest(".gal-btn");
      if (galBtn) {
        var strip = galBtn.closest(".gal-row").querySelector(".gal-strip");
        if (strip) {
          var item = strip.querySelector(".gal-item");
          var step = item ? (item.getBoundingClientRect().width + 16) * 2 : 480;
          strip.scrollBy({ left: step * Number(galBtn.dataset.dir || 1), behavior: "smooth" });
        }
        return;
      }

      /* Lightbox open */
      var lbItem = e.target.closest(".lb-item");
      if (lbItem) {
        var tpl = lbItem.querySelector("template.lb-full");
        if (tpl) lbOpen(tpl);
        return;
      }

      /* Lightbox close (backdrop or close button) */
      var lb = document.getElementById("theme-lightbox");
      if (lb && !lb.hidden && (e.target === lb || e.target.closest(".lightbox-close"))) {
        lbClose();
      }
    });

    document.addEventListener("keydown", function (e) {
      var lb = document.getElementById("theme-lightbox");
      if (e.key === "Escape" && lb && !lb.hidden) lbClose();
      if ((e.key === "Enter" || e.key === " ") &&
          document.activeElement && document.activeElement.classList.contains("lb-item")) {
        e.preventDefault();
        var tpl = document.activeElement.querySelector("template.lb-full");
        if (tpl) lbOpen(tpl);
      }
    });
  }

  function initAll(root) {
    initAnnounce();
    initHeader(root);
    initFaq(root);
    initProduct(root);
    initReveal(root);
    bindDelegates();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: re-init when a section is (re)loaded, and show hidden reveals */
  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
    e.target.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
  });
})();
